export interface ServerConfig {
  protocol: string;
  host: string;
  port: number;
  path: string;
  profileImagesUploadPath: string;
}

export interface AppConfig {
  basePath: string;
  server: ServerConfig;
  appVersion: string;
  cleanStorage: boolean;
}

const port = Number(import.meta.env.VITE_API_PORT || 4000);
const protocol = import.meta.env.VITE_API_PROTOCOL || 'http';
const host = import.meta.env.VITE_API_HOST || 'localhost';

const config: AppConfig = {
  basePath: '/',
  server: {
    protocol,
    host,
    port,
    path: '/graphql',
    profileImagesUploadPath: '/profile-pics',
  },
  appVersion: import.meta.env.VITE_APP_VERSION || 'admin-1.0.0-dev',
  cleanStorage: false,
};

export function getServerUrl(cfg: AppConfig = config): string {
  const p = cfg.server.port > 0 ? `:${cfg.server.port}` : '';
  return `${cfg.server.protocol}://${cfg.server.host}${p}`;
}

export function getGraphqlUrl(cfg: AppConfig = config): string {
  return `${getServerUrl(cfg)}${cfg.server.path}`;
}

export function getSubscriptionsUrl(cfg: AppConfig = config): string {
  const wsProtocol = cfg.server.protocol === 'https' ? 'wss' : 'ws';
  const p = cfg.server.port > 0 ? `:${cfg.server.port}` : '';
  return `${wsProtocol}://${cfg.server.host}${p}/subscriptions`;
}

export default config;
